<template>
  <div class="checkbox" @click="changeChecked">
    <i v-if="isAgree" class="iconfont icon-checked"></i>
    <i v-else class="iconfont icon-unchecked"></i>
    <span v-if="$slots.default"><slot /></span>
  </div>
</template>
<script>
// import { useVModel } from '@vueuse/core'
export default {
  name: 'CheckboxComponent',
  props: {
    /* modelValue: {
      type: Boolean,
      default: false
    } */
    isAgree: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    /* const checked = useVModel(props, 'modelValue', emit)
    const changeChecked = () => {
      const newVal = !checked.value
      checked.value = newVal
      emit('change', newVal)
    }
    return { checked, changeChecked } */

    const changeChecked = () => {
      const newVal = props.isAgree
      emit('change', !newVal)
    }

    return {
      changeChecked
    }
  }
}
</script>
<style scoped lang="less">
.checkbox {
  display: inline-block;
  margin-right: 2px;
  cursor: pointer;
  .icon-checked {
    color: @appColor;
    ~ span {
      color: @appColor;
    }
  }
  i {
    position: relative;
    top: 1px;
  }
  span {
    margin-left: 2px;
  }
}
</style>
